.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.head {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.head-text {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  min-width: 0;
}

/* Visible source label — the section's origin must not be carried by colour
   alone (Melhoria 6 §15). */
.badge {
  background: var(--color-background-info, #e5f2ff);
  border-radius: 6px;
  color: var(--color-text-info, #339cff);
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  white-space: nowrap;
}

.title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 2px;
}

/* Narrow viewports scroll this table inside its own section rather than moving
   the whole preview sideways (§15). */
.scroll {
  overflow-x: auto;
}

.table {
  border-collapse: collapse;
  min-width: 520px;
  width: 100%;

  th,
  td {
    border-bottom: 1px solid var(--color-border, #e2e4e9);
    padding: 12px 10px;
    text-align: left;
  }

  th {
    color: var(--color-text-muted, #535862);
    font-size: 13px;
    font-weight: 600;
  }

  td {
    font-size: 14px;
  }

  tr:last-child td {
    border-bottom: 0;
  }
}

.action-col {
  text-align: right;
  white-space: nowrap;
}

.file {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.file-icon {
  color: var(--color-text-muted, #565b65);
  flex-shrink: 0;
}

.file-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.file-link {
  background: none;
  border: none;
  color: var(--color-text, #202328);
  cursor: pointer;
  font: inherit;
  overflow-wrap: anywhere;
  padding: 0;
  text-align: left;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.file-link:disabled {
  cursor: progress;
  opacity: 0.7;
}

.featured {
  align-items: center;
  color: var(--color-text-warning, #e25507);
  display: flex;
  font-size: 11px;
  font-weight: 600;
  gap: 3px;
}

.open {
  align-items: center;
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #d4d7dd);
  border-radius: 8px;
  color: var(--color-text, #17191d);
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  gap: 6px;
  padding: 7px 12px;
  text-decoration: none;

  &:hover:not(:disabled) {
    background: var(--color-surface-hover, #f6f7f8);
  }
}

.open:disabled {
  cursor: progress;
  opacity: 0.7;
}

@media (max-width: 720px) {
  .head {
    flex-direction: column;
  }
}
